<template>
    <div
        class="button-date-wrapper"
        style="min-width: 250px"
    >
        <d-button
        theme="light"
        class="ml-0 text-left w-100"
        style="background-color: transparent; border: none"
        >
            {{ label }}
        </d-button>
        <ss-date
        @picked="handlePicked"
        type="text"
        name="certificate-of-balance-date"
        v-model="pickedDate"
        placeholder=""/>
    </div>
</template>

<script>
import SsDate from '@/components/common/SsDate';
import moment from 'moment'

export default {
  props: {
    label: String,
    id: Number
  },
  components: {
    SsDate
  },
  methods: {
    handlePicked(){
        setTimeout(() => {
            this.$emit('picked', { id: this.id, date: this.pickedDate })
        }, 200)
    }
  },
  data() {
    return {
        pickedDate: moment().add(7, 'days').format('YYYY-MM-DD'),
    }
  }
}
</script>